import { render, staticRenderFns } from "./RegistroInventarioComponent.vue?vue&type=template&id=2c269afd"
import script from "./RegistroInventarioComponent.vue?vue&type=script&lang=js"
export * from "./RegistroInventarioComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports